import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { EditContext } from "../../Context/EditContext";
import { AppContext } from "../../Context/AppContext";
import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";
import * as api from "../../api/index";
import InvoicesPayment from "../../admin/InvoicesPayment";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import CallReceivedIcon from "@material-ui/icons/CallReceived";
import CallMadeIcon from "@material-ui/icons/CallMade";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import LanguageIcon from "@material-ui/icons/Language";
import Typography from "@material-ui/core/Typography";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import Avatar from "@material-ui/core/Avatar";
import {
  makeStyles,
  useTheme,
} from "@material-ui/core/styles";
import { useEffectiveProfile } from "../../utils/useEffectiveProfile";
import { getCurrencySymbol } from "../../utils/currency";
import useMediaQuery from "@material-ui/core/useMediaQuery";
// import { toCommas } from "../../utils/utils";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { getClientsByUser, getAllClients } from "../../actions/clientActions";
import { useSnackbar } from "../../utils/useSnackbar";
import { Container } from "@material-ui/core";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import AddClient from "../Invoice/AddClient";
import {
  getInvoicesByClient,
  updateInvoice,
} from "../../actions/invoiceActions";
import {
  createMeeting,
  getMeeting,
  updateMeeting,
} from "../../actions/meetingActions";
import UnsavedChangesGuard from "../UnsavedChangesGuard/UnsavedChangesGuard";
import { useConfirmation } from "../../Context/ConfirmationContext";

// Plain float arithmetic across several invoices' balances drifts (e.g.
// 0.1 + 0.2), and that drift used to land straight in totalDueAmount and the
// per-invoice write-off amounts below.
const roundMoney = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

const useStyles = makeStyles((theme) => ({
  formField: {
    marginBottom: theme.spacing(2),
  },
  dialogTitle: {
    backgroundColor: "#ef7f1a", // Replace 'primary.main' with your desired blue color
    color: "#fff", // White text color
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "white",
  },
}));

const MeetingForm = ({ onClose }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const { openPaymentModal, setOpenPaymentModal } = useContext(AppContext);
  const [client, setClient] = useState(null);
  const [touched, setTouched] = useState(false);
  const { currId, setCurrId, customerId, setCustomerId } =
    useContext(EditContext);
  const location = useLocation();
  const [totalDueAmount, setTotalDueAmount] = useState(0);
  const user = JSON.parse(localStorage.getItem("profile"));
  const profile = useEffectiveProfile();
  const currencySymbol = getCurrencySymbol(profile?.currency);
  const dispatch = useDispatch();
  const [openSnackbar] = useSnackbar();
  const history = useHistory();
  const { invoices } = useSelector((state) => state.invoices);
  const clients = useSelector((state) => state.clients.clients);

  useEffect(() => {
    if (customerId) {
      dispatch(getInvoicesByClient(customerId._id));
    }else if(client){
      dispatch(getInvoicesByClient(client._id));
    }
    setOpenPaymentModal(true);
  }, [dispatch, customerId,client]);
  useEffect(() => {
    dispatch(
      // getClientsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllClients()
    );

    // eslint-disable-next-line
  }, [dispatch]);
  //(clients);
  // const { meeting } = useSelector((state) => state.meetings);
  const [advance, setAdvance] = useState({
    cash: "",
    cheque: "",
  });
  const stateMeetings = useSelector((state) => state.meetings?.meetings || []);
  const meetingFromState = currId
    ? stateMeetings.find((c) => c._id === currId)
    : null;
  const [loadedMeeting, setLoadedMeeting] = useState(null);
  const [fetchingMeeting, setFetchingMeeting] = useState(false);

  useEffect(() => {
    let isMounted = true;
    if (currId) {
      if (meetingFromState) {
        setLoadedMeeting(meetingFromState);
      } else {
        setFetchingMeeting(true);
        api
          .fetchMeeting(currId)
          .then((res) => {
            if (isMounted && res.data) {
              setLoadedMeeting(res.data);
            }
          })
          .catch((err) => {
            console.error("Failed to fetch meeting", err);
            openSnackbar("Failed to load payment/receipt details", "error");
          })
          .finally(() => {
            if (isMounted) setFetchingMeeting(false);
          });
      }
    } else {
      setLoadedMeeting(null);
    }
    return () => {
      isMounted = false;
    };
  }, [currId, meetingFromState, openSnackbar]);

  const meeting = loadedMeeting || meetingFromState;
  // //(meeting);

  const [formData, setFormData] = useState({
    remarks: "",
    payment: "",
    discount:0,
    amountPaid:0,
    date: new Date(),
    paymentMode: "Cash",
    transactionType: "Receipt",
  });
  const initialFormData = {
    remarks: "",
    payment: "",
    discount:0,
    amountPaid:0,
    date: new Date(),
    paymentMode: "Cash",
    transactionType: "Receipt",
    // Add other form fields and their initial values here
  };
  const [errors, setErrors] = useState({
    remarks: "",
    payment: "",
    client: "",
    discount:"",
    amountPaid:"",
    paymentMode: "",
    transactionType: "",
  });

  // const handleFieldChange = (event) => {
  //   const { name, value } = event.target;
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [name]: value,
  //   }));
  // };
  const handleFieldChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    // Clear the error message for the changed field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const toCommas = (value) => {
    const num = Number(value);
    if (Number.isNaN(num)) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    const [intPart, decPart] = num.toFixed(2).split(".");
    return `${intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${decPart}`;
  };
  // const handleTime = (time) => {
  //   //(time);
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     time: time,
  //   }));
  // };
  const handleDate = (date) => {
    //();
    const formattedDate = date.toISOString().split("T")[0];
    setFormData((prevFormData) => ({
      ...prevFormData,
      date: formattedDate,
    }));
  };
  const handleClientChange = () => {
    setTouched(true);
    setErrors((prevErrors) => ({
      ...prevErrors,
      client: "",
    }));
  };
  const confirm = useConfirmation();

  const isFormDirty = () => {
    if (meeting) {
      const origPayment = String(meeting.payment ?? meeting.amount ?? "");
      const currPayment = String(formData.payment ?? "");
      const origRemarks = String(meeting.remarks || "");
      const currRemarks = String(formData.remarks || "");
      const origDiscount = Number(meeting.discount || 0);
      const currDiscount = Number(formData.discount || 0);
      const origMode = String(meeting.paymentMode || "Cash");
      const currMode = String(formData.paymentMode || "Cash");
      const origType = String(meeting.transactionType || "Receipt");
      const currType = String(formData.transactionType || "Receipt");
      return (
        origPayment !== currPayment ||
        origRemarks !== currRemarks ||
        origDiscount !== currDiscount ||
        origMode !== currMode ||
        origType !== currType
      );
    }
    const hasPayment = formData.payment !== "" && Number(formData.payment) > 0;
    const hasRemarks = Boolean(formData.remarks && formData.remarks.trim());
    const hasDiscount = Boolean(Number(formData.discount) > 0);
    return hasPayment || hasRemarks || hasDiscount;
  };

  const handleCancel = async () => {
    if (isFormDirty()) {
      const ok = await confirm({
        title: "Discard Payment Changes?",
        message: "You have unsaved changes on this payment. Are you sure you want to discard them?",
        confirmLabel: "Discard & Leave",
        cancelLabel: "Stay",
        confirmColor: "#d32f2f",
      });
      if (!ok) return;
    }
    setFormData({
      remarks: "",
      payment: "",
      discount: 0,
      amountPaid: 0,
      date: new Date(),
      paymentMode: "Cash",
      transactionType: "Receipt",
    });
    onClose?.();
    setCurrId(null);
  };
  useEffect(() => {
    if (meeting) {
      setFormData({
        remarks: meeting.remarks || "",
        payment: meeting.payment ?? meeting.amount ?? "",
        discount: meeting.discount || 0,
        amountPaid: meeting.amountPaid || 0,
        date: meeting.createdAt
          ? new Date(meeting.createdAt).toISOString().split("T")[0]
          : meeting.date
          ? new Date(meeting.date).toISOString().split("T")[0]
          : new Date().toISOString().split("T")[0],
        paymentMode: meeting.paymentMode || "Cash",
        transactionType: meeting.transactionType || "Receipt",
        appliedInvoices: meeting.appliedInvoices || [],
      });
      setClient(meeting.client || null);
      if (meeting.client?._id) {
        dispatch(getInvoicesByClient(meeting.client._id));
      }
    }
  }, [meeting, dispatch]);
  useEffect(() => {
    if (customerId) {
      setClient(customerId);
      // setAdvance(meeting.advance);
    }
  }, [customerId]);

  // useEffect(() => {
  //   // Add a "beforeunload" event listener to prompt the user before leaving the page
  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   // Remove the event listener when the component unmounts
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  // const handleBeforeUnload = (event) => {
  //   // Check if the form has unsaved changes and display a confirmation message
  //   if (isFormDirty()) {
  //     event.preventDefault();
  //     event.returnValue =
  //       "You have unsaved changes. Are you sure you want to leave?";
  //   }
  // };
  useEffect(() => {
    const totalDue = invoices.reduce((total, invoice) => {
      // A return already reduces what the customer actually owes
      // (invoice.currentTotal, maintained by updateInvoiceReturns on the
      // server) - reading invoice.total unconditionally overstated the due
      // amount for any invoice with an approved return against it.
      const effectiveTotal = invoice.returnsProcessed > 0 ? invoice.currentTotal : invoice.total;
      return (
        total +
        (Number(effectiveTotal || 0) - Number(invoice.totalAmountReceived || 0))
      );
    }, 0);
    setTotalDueAmount(roundMoney(totalDue));
  }, [invoices]);

  // const handleWriteOff = () => {
  //   // Sort invoices by oldest first (FIFO approach)
  //   const sortedInvoices = [...invoices].sort(
  //     (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
  //   );

  //   let remainingAmount = Number(formData.payment);
  //   const updatedInvoices = sortedInvoices.map((invoice) => {
  //     const remainingBalance =
  //       Number(invoice.total) - Number(invoice.totalAmountReceived || 0);

  //     if (remainingAmount > 0 && remainingBalance > 0) {
  //       const amountToApply = Math.min(remainingAmount, remainingBalance);

  //       const newTotalAmountReceived =
  //         Number(invoice.totalAmountReceived || 0) + amountToApply;
  //       const newStatus =
  //         newTotalAmountReceived >= invoice.total ? "Paid" : "Partial";

  //       const newPaymentRecord = {
  //         amountPaid: amountToApply,
  //         datePaid: formData.date || new Date(),
  //         paymentMethod: formData?.paymentMode || "Not Specified",
  //         note: "Bulk Payment Writeoff",
  //       };

  //       remainingAmount -= amountToApply;

  //       return {
  //         ...invoice,
  //         status: newStatus,
  //         totalAmountReceived: newTotalAmountReceived,
  //         paymentRecords: [...(invoice.paymentRecords || []), newPaymentRecord],
  //       };
  //     }

  //     return invoice;
  //   });

  //   // Dispatch updates for each invoice
  //   updatedInvoices.forEach((invoice) => {
  //     if (invoice.totalAmountReceived !== invoice.originalTotalAmountReceived) {
  //       dispatch(updateInvoice(invoice._id, invoice));
  //     }
  //   });
  // };

  // Applies one customer payment across their outstanding invoices, oldest
// first, until the amount runs out.
const handleWriteOff = (isUpdate = false, previousPayment = 0) => {
  const targetClientId = customerId?._id || client?._id;
  const clientOnlyInvoices = (invoices || []).filter((inv) => {
    if (!targetClientId) return true;
    const invClientId = inv.client?._id || inv.client;
    return String(invClientId) === String(targetClientId);
  });
  const sortedInvoices = [...clientOnlyInvoices].sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
  );

  // If updating, we need to account for the difference from previous payment
  let paymentAmount = Number(formData.payment);
  if (isUpdate) {
    paymentAmount = paymentAmount - previousPayment;
  }

  let remainingAmount = roundMoney(paymentAmount);
  // Only invoices actually touched below get sent back to the server - the
  // previous version compared invoice.totalAmountReceived against a
  // "originalTotalAmountReceived" field that was never set on any invoice,
  // so that check was always true and every one of this customer's
  // invoices got re-saved on every payment, whether this wrote anything
  // against it or not (each stamped "Modified", each an unnecessary write).
  const touchedInvoiceIds = new Set();
  const appliedInvoicesList = [];

  const updatedInvoices = sortedInvoices.map((invoice) => {
    // A return already reduces what's actually owed on this invoice - see
    // the same fix in the totalDueAmount effect above.
    const effectiveTotal = invoice.returnsProcessed > 0 ? invoice.currentTotal : invoice.total;
    const remainingBalance = roundMoney(
      Number(effectiveTotal || 0) - Number(invoice.totalAmountReceived || 0)
    );

    if (remainingAmount > 0 && remainingBalance > 0) {
      const amountToApply = roundMoney(Math.min(remainingAmount, remainingBalance));

      const newTotalAmountReceived = roundMoney(
        Number(invoice.totalAmountReceived || 0) + amountToApply
      );
      const newStatus =
        newTotalAmountReceived >= Number(effectiveTotal || 0) ? "Paid" : "Partial";

      const newPaymentRecord = {
        amountPaid: amountToApply,
        datePaid: formData.date || new Date(),
        paymentMethod: formData?.paymentMode || "Not Specified",
        note: isUpdate ? "Payment Updated" : "Bulk Payment Writeoff",
      };

      remainingAmount = roundMoney(remainingAmount - amountToApply);
      touchedInvoiceIds.add(invoice._id);
      appliedInvoicesList.push({
        invoiceId: invoice._id,
        invoiceNumber: invoice.invoiceNumber,
        amountApplied: amountToApply,
      });

      return {
        ...invoice,
        status: newStatus,
        totalAmountReceived: newTotalAmountReceived,
        paymentRecords: [...(invoice.paymentRecords || []), newPaymentRecord],
      };
    }
    return invoice;
  });

  // Update only the invoices this payment actually applied to.
  updatedInvoices.forEach((invoice) => {
    if (touchedInvoiceIds.has(invoice._id)) {
      dispatch(updateInvoice(invoice._id, invoice));
    }
  });

  // Recalculate total due amount after update
  const newTotalDue = updatedInvoices.reduce((total, invoice) => {
    const effectiveTotal = invoice.returnsProcessed > 0 ? invoice.currentTotal : invoice.total;
    return total + (Number(effectiveTotal || 0) - Number(invoice.totalAmountReceived || 0));
  }, 0);
  setTotalDueAmount(roundMoney(newTotalDue));

  // The payment collected more than this customer owed - the excess isn't
  // applied anywhere (there's no store-credit/advance ledger for it yet),
  // so surface it instead of silently swallowing the difference.
  if (remainingAmount > 0) {
    openSnackbar(
      `${currencySymbol} ${remainingAmount.toFixed(2)} of this payment exceeds the customer's outstanding balance and was not applied to any invoice.`,
      'warning'
    );
  }
  return appliedInvoicesList;
};


  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   ;
  //   const requiredFields = ["date", "paymentMode", "payment"];
  //   const fieldErrors = {};

  //   requiredFields.forEach((field) => {
  //     if (!formData[field]) {
  //       fieldErrors[field] = "This field is required.";
  //     }
  //   });
  //   // //("Client", client);
  //   if (!client || client === null) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       client: "Customer name is required.",
  //     }));
  //     return;
  //   }

  //   setErrors(fieldErrors);

  //   // If there are any errors, stop the form submission
  //   if (Object.keys(fieldErrors).length > 0) {
  //     return;
  //   }

    
  //   if (currId) {
  //     dispatch(
  //       updateMeeting(currId, {
  //         ...formData,
  //         client,
  //       })
  //     );
      
  //     // history.push(`/meeting/${meeting._id}`);
  //   } else {
  //     //("in create New");
  //     console.log("Form Data", formData);
  //     //("Advances", advance);

  //     dispatch(
  //       createMeeting({
  //         ...formData,
  //         client,
  //         creator: [user?.result?._id || user?.result?.googleId],
  //         createdAt: formData.date,
  //         // history
  //       })
  //     );
  //     handleWriteOff()
  //   }
  //   setFormData({
  //     remarks: "",
  //     payment: "",
  //     discount:0,
  //     amountPaid:0,
  //     date: new Date(),
  //     paymentMode: "Cash",
  //   });
  //   setCurrId(null);
  //   onClose();
  //   window.location.reload()
  // };


// Update handleSubmit to handle both create and update cases
const handleSubmit = (event) => {
  event.preventDefault();
  
  const requiredFields = ["date", "paymentMode", "payment"];
  const fieldErrors = {};

  requiredFields.forEach((field) => {
    if (!formData[field]) {
      fieldErrors[field] = "This field is required.";
    }
  });

  if (formData.payment && Number(formData.payment) <= 0) {
    fieldErrors.payment = "Amount must be greater than 0.";
  }

  if (!client || client === null) {
    setErrors((prevErrors) => ({
      ...prevErrors,
      client: "Customer name is required.",
    }));
    return;
  }

  setErrors(fieldErrors);

  if (Object.keys(fieldErrors).length > 0) {
    return;
  }

  // Real-world accounting: a Receipt is money coming IN from this customer,
  // which is what actually pays down their invoices - so only a Receipt
  // gets written off against their outstanding balance. A Payment here is
  // money going OUT to the customer (a refund, a reimbursement) - applying
  // that the same way would make their unpaid invoices look paid down when
  // no such money was ever collected from them. It's still recorded as a
  // transaction (for cash reconciliation) but never touches invoice balances.
  const isReceipt = formData.transactionType === 'Receipt';

  if (currId) {
    const previousPayment = meeting ? Number(meeting.payment || 0) : 0;
    let appliedInvoices = [];
    if (isReceipt) {
      appliedInvoices = handleWriteOff(true, previousPayment);
    }

    dispatch(
      updateMeeting(currId, {
        ...formData,
        client,
        appliedInvoices:
          appliedInvoices.length > 0
            ? appliedInvoices
            : meeting?.appliedInvoices || [],
      })
    ).then(() => {
      if (client?._id) {
        dispatch(getInvoicesByClient(client._id));
      }
    });
  } else {
    let appliedInvoices = [];
    if (isReceipt) {
      appliedInvoices = handleWriteOff();
    }

    dispatch(
      createMeeting({
        ...formData,
        client,
        appliedInvoices,
        creator: [user?.result?._id || user?.result?.googleId],
        createdAt: formData.date,
      })
    ).then(() => {
      if (client?._id) {
        dispatch(getInvoicesByClient(client._id));
      }
    });
  }

  setFormData({
    remarks: "",
    payment: "",
    discount: 0,
    amountPaid: 0,
    date: new Date(),
    paymentMode: "Cash",
  });
  setCurrId(null);
  onClose();
  // Remove window.location.reload() as we'll handle state updates properly
};


  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => option.name,
  };
  const [open, setOpen] = useState(false);

  return (
    <>
      <UnsavedChangesGuard
        when={isFormDirty()}
        message="You have unsaved changes on this payment. Are you sure you want to leave without saving?"
      />
      <AddClient setOpen={setOpen} open={open} />

      <Dialog
        open
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleCancel();
          }
        }}
        fullWidth
        maxWidth="sm"
        fullScreen={isMobile}
        PaperProps={{ style: { borderRadius: isMobile ? 0 : 12 } }}
      >
        <DialogTitle
          id="customized-dialog-title"
          className={classes.dialogTitle}
          style={{ padding: "14px 20px" }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 4, paddingRight: 40 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
              <Typography variant="h6" style={{ fontWeight: 700, color: "#ffffff", lineHeight: 1.2 }}>
                {currId
                  ? `Edit ${formData.transactionType || "Record"}`
                  : "Add Payment / Receipt"}
              </Typography>
              {currId && (
                <span
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    color: "#ffffff",
                    fontSize: "11px",
                    fontWeight: 600,
                    padding: "2px 8px",
                    borderRadius: "10px",
                    border: "1px solid rgba(255, 255, 255, 0.35)",
                    letterSpacing: "0.5px",
                  }}
                >
                  ID: {String(currId).slice(-6).toUpperCase()}
                </span>
              )}
            </div>
            {currId && (client?.name || formData.payment) && (
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginTop: 2 }}>
                {client?.name && (
                  <span
                    style={{
                      backgroundColor: "#ffffff",
                      color: "#b45309",
                      fontSize: "12px",
                      fontWeight: 700,
                      padding: "2px 8px",
                      borderRadius: "6px",
                    }}
                  >
                    {client.name}
                  </span>
                )}
                {formData.payment ? (
                  <span
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.2)",
                      color: "#ffffff",
                      fontSize: "12px",
                      fontWeight: 700,
                      padding: "2px 8px",
                      borderRadius: "6px",
                    }}
                  >
                    {currencySymbol} {toCommas(formData.payment)}
                  </span>
                ) : null}
              </div>
            )}
          </div>
          {onClose ? (
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={handleCancel}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent className="slim-scrollbar">
          {fetchingMeeting ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "50px 0",
                gap: 12,
              }}
            >
              <CircularProgress size={36} style={{ color: "#ef7f1a" }} />
              <Typography variant="body2" style={{ color: "#64748b" }}>
                Loading payment/receipt details...
              </Typography>
            </div>
          ) : (
            <>
          {client && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 8,
                padding: "10px 14px",
                backgroundColor: "#f8fafc",
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                marginBottom: 16,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "2px 8px",
                    borderRadius: "6px",
                    backgroundColor: formData.transactionType === "Receipt" ? "#dcfce7" : "#fee2e2",
                    color: formData.transactionType === "Receipt" ? "#15803d" : "#b91c1c",
                    fontWeight: 700,
                    fontSize: "0.8125rem",
                  }}
                >
                  {formData.transactionType || "Receipt"}
                </span>
                <span style={{ fontSize: "0.875rem", color: "#1e293b", fontWeight: 700 }}>
                  {client.name}
                </span>
                {client.phone && (
                  <span style={{ fontSize: "0.8125rem", color: "#64748b" }}>
                    ({client.phone})
                  </span>
                )}
              </div>
              {totalDueAmount > 0 && (
                <div style={{ fontSize: "0.8125rem", color: "#475569" }}>
                  <span style={{ color: "#94a3b8", fontWeight: 500 }}>Total Due: </span>
                  <strong style={{ color: "#c2410c" }}>
                    {currencySymbol} {totalDueAmount.toFixed(2)}
                  </strong>
                </div>
              )}
            </div>
          )}
          <form onSubmit={handleSubmit}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={12} sm={6}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      label="Date"
                      name="date"
                      value={formData.date}
                      onChange={handleDate}
                      required
                      fullWidth
                      format="MMM dd, yyyy"
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Container>
                    {client && (
                      <>
                        <Typography variant="subtitle1" gutterBottom>
                          {client.name}
                        </Typography>

                        <Typography variant="body2">
                          {client.agentCode}
                        </Typography>
                        <Typography variant="body1">{client.phone}</Typography>
                        <Button
                          color="primary"
                          size="small"
                          style={{
                            textTransform: "none",
                            backgroundColor: "#ef7f1a",
                            color: "white",
                          }}
                          onClick={() => setClient(null)}
                        >
                          Change
                        </Button>
                      </>
                    )}
                    <div
                      style={
                        client ? { display: "none" } : { display: "block" }
                      }
                    >
                      <Autocomplete
                        {...clientsProps}
                        // PaperComponent={CustomPaper}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            // required={!invoice && true}
                            label="Select Customer"
                            margin="normal"
                            variant="outlined"
                            error={touched && !!errors.client}
                            helperText={touched && errors.client}
                          />
                        )}
                        value={clients?.name}
                        onChange={(event, value) => {
                          setClient(value);
                          handleClientChange();
                        }}
                        // onChange={(event, value) => setClient(value) }
                      />
                    </div>
                    {!client && (
                      <>
                        <Grid item style={{ paddingBottom: "10px" }}>
                          <Chip
                            avatar={
                              <Avatar
                                style={{
                                  backgroundColor: "#ef7f1a",
                                  color: "white",
                                }}
                              >
                                +
                              </Avatar>
                            }
                            label="New Customer"
                            onClick={() => setOpen(true)}
                            variant="outlined"
                          />
                        </Grid>
                      </>
                    )}
                  </Container>
                </Grid>
                {client && (
                  <Grid item xs={12}>
                    <Box
                      p={1.25}
                      bgcolor={totalDueAmount > 0 ? "#fff7ed" : "#f0fdf4"}
                      border={`1px solid ${totalDueAmount > 0 ? "#fed7aa" : "#bbf7d0"}`}
                      borderRadius={8}
                    >
                      <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 700, color: totalDueAmount > 0 ? "#c2410c" : "#15803d" }}
                      >
                        Total Due: {currencySymbol} {totalDueAmount.toFixed(2)}
                      </Typography>
                      {Number(formData.payment) > 0 && formData.transactionType === 'Receipt' && (
                        <Typography variant="body2" style={{ marginTop: 4, color: "#475569" }}>
                          After this receipt of {currencySymbol} {roundMoney(formData.payment).toFixed(2)}, remaining
                          due:{" "}
                          <strong>
                            {currencySymbol} {Math.max(0, roundMoney(totalDueAmount - Number(formData.payment))).toFixed(2)}
                          </strong>
                          {Number(formData.payment) > totalDueAmount && (
                            <span style={{ color: "#b45309" }}>
                              {" "}
                              ({currencySymbol} {roundMoney(Number(formData.payment) - totalDueAmount).toFixed(2)} won't be applied to any invoice)
                            </span>
                          )}
                        </Typography>
                      )}
                      {Number(formData.payment) > 0 && formData.transactionType === 'Payment' && (
                        <Typography variant="body2" style={{ marginTop: 4, color: "#475569" }}>
                          Recorded as {currencySymbol} {roundMoney(formData.payment).toFixed(2)} paid out to this
                          customer - this due amount is not affected.
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <FormLabel labelplacement="start">Payment Mode</FormLabel>
                  <RadioGroup
                    name="paymentMode"
                    value={formData.paymentMode}
                    onChange={handleFieldChange}
                    row
                  >
                    <FormControlLabel
                      value="Cash"
                      control={<Radio style={{ color: "#ef7f1a" }} />}
                      label={
                        <Box display="flex" alignItems="center" gridGap={4}>
                          <LocalAtmIcon style={{ fontSize: 18, color: "#64748b" }} /> Cash
                        </Box>
                      }
                    />
                    <FormControlLabel
                      value="Online"
                      control={<Radio style={{ color: "#ef7f1a" }} />}
                      label={
                        <Box display="flex" alignItems="center" gridGap={4}>
                          <LanguageIcon style={{ fontSize: 18, color: "#64748b" }} /> Online
                        </Box>
                      }
                    />
                    <FormControlLabel
                      value="Card"
                      control={<Radio style={{ color: "#ef7f1a" }} />}
                      label={
                        <Box display="flex" alignItems="center" gridGap={4}>
                          <CreditCardIcon style={{ fontSize: 18, color: "#64748b" }} /> Card
                        </Box>
                      }
                    />
                  </RadioGroup>
                  {!!errors.paymentMode && (
                    <Typography variant="body2" color="error">
                      {errors.paymentMode}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Box display="flex" alignItems="center" gridGap={4}>
                    <FormLabel labelplacement="start">Transaction Type</FormLabel>
                    <Tooltip
                      title={
                        <>
                          <div>
                            <strong>Receipt</strong> - money received FROM this customer. Applied to pay down their
                            oldest outstanding invoices first.
                          </div>
                          <div style={{ marginTop: 6 }}>
                            <strong>Payment</strong> - money paid OUT to this customer (e.g. a refund). Recorded for
                            your records, but does not change their invoice balance.
                          </div>
                        </>
                      }
                    >
                      <InfoOutlinedIcon style={{ fontSize: 16, color: "#94a3b8", cursor: "help" }} />
                    </Tooltip>
                  </Box>
                  <RadioGroup
                    name="transactionType"
                    value={formData.transactionType}
                    onChange={handleFieldChange}
                    row
                  >
                    <FormControlLabel
                      value="Receipt"
                      control={<Radio style={{ color: "#ef7f1a" }} />}
                      label={
                        <Box display="flex" alignItems="center" gridGap={4}>
                          <CallReceivedIcon style={{ fontSize: 18, color: "#15803d" }} /> Receipt (money in)
                        </Box>
                      }
                    />
                    <FormControlLabel
                      value="Payment"
                      control={<Radio style={{ color: "#ef7f1a" }} />}
                      label={
                        <Box display="flex" alignItems="center" gridGap={4}>
                          <CallMadeIcon style={{ fontSize: 18, color: "#b91c1c" }} /> Payment (money out)
                        </Box>
                      }
                    />
                  </RadioGroup>
                  {!!errors.transactionType && ( // Display error message conditionally
                    <Typography variant="body2" color="error">
                      {errors.transactionType}
                    </Typography>
                  )}
                </Grid>

                <>
                  <Grid item xs={12}>
                    <TextField
                      label="Amount"
                      name="payment"
                      type="number"
                      value={formData.payment}
                      onChange={handleFieldChange}
                      fullWidth
                      className={classes.formField}
                      variant="outlined"
                      size="small"
                      error={!!errors.payment} // Set error prop based on error existence
                      helperText={errors.payment} // Display error message
                    />
                  </Grid>
                </>

                <Grid item xs={12}>
                  <TextField
                    label="Remarks"
                    name="remarks"
                    value={formData.remarks}
                    onChange={handleFieldChange}
                    fullWidth
                    multiline
                    maxRows={4}
                    className={classes.formField}
                    variant="outlined"
                    size="small"
                    error={!!errors.remarks} // Set error prop based on error existence
                    helperText={errors.remarks} // Display error message
                  />
                </Grid>
              </Grid>
          </form>
            </>
          )}
        </DialogContent>
        <DialogActions style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={handleCancel}
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            // color="primary"
            style={{ backgroundColor: "#ef7f1a", color: "white", textTransform: "none" }}
            onClick={handleSubmit}
            fullWidth={isMobile}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MeetingForm;
